<template>
  <el-dialog v-model="isVisible" :id="id" :class="{ 'modal-sms': isSms }">
    <form v-if="!loadingModal && isVisible" class="actions-message">
      <div class="ac-form">
        <h2>{{ titleMessage }}</h2>

        <div class="row mt-3" v-if="isNotSms">
          <div class="col-6">
            <!-- scope -->
            <div class="actions-message__scope form-group">
              <label>{{ $t('campaign.messages.scope') }}</label>
              <v-select
                v-model="scope"
                label="name"
                class="w-100"
                :clearable="false"
                :reduce="item => item.id"
                :options="scopeList"
                :placeholder="$t('select')"
                @option:selected="changeScope"
                :disabled="actionPage"
              >
                <template #option="{ name }">
                  {{ $tc(`${name}`, 3) }}
                </template>
                <template #selected-option="{ name }">
                  {{ $tc(`${name}`, 3) }}
                </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes" class="arrow-down"></span>
                </template>
                <template #no-options>
                  {{ $t('campaign.messages.no-results') }}
                </template>
              </v-select>
            </div>
          </div>

          <!-- scope / value -->
          <div class="col-6">
            <label>{{ $t('campaign.messages.value') }}</label>
            <v-select
              v-model="scopeValue"
              label="name"
              :clearable="false"
              :loading="loadingScope"
              :disabled="checkScopeBrand() || actionPage"
              :options="scopeValueList"
              :placeholder="$t('select')"
            >
              <template #option="{ name }">
                <span :title="$tc(name, 1)">{{ $tc(name, 1) }}</span>
              </template>
              <template #selected-option="{ name }">
                {{ $tc(`${name}`, 1) }}
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes" class="arrow-down"></span>
              </template>
              <template #no-options>
                {{ $t('campaign.messages.no-results') }}
              </template>
            </v-select>
          </div>
        </div>

        <div class="row mt-2" v-if="isNotSms">
          <!-- channel -->
          <div class="col-6">
            <label>{{ $t('campaign.messages.channel') }}</label>
            <v-select
              v-model="channel"
              :reduce="item => item.id"
              label="name"
              :clearable="false"
              :options="channelTypes"
              :placeholder="$t('select')"
              :disabled="actionPage"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes" class="arrow-down"></span>
              </template>
              <template #no-options>
                {{ $t('campaign.messages.no-results') }}
              </template>
            </v-select>
          </div>
        </div>

        <!-- dragndrop area -->
        <div class="container drag-drop">
          <label>{{ $t('campaign.messages.message') }}</label>
          <el-tooltip
            @show="showMessageError"
            :visible="containsDuplicateMessages || showSpecialCharTooltip"
            :raw-content="true"
            :content="tooltipMessage"
            placement="right"
            popper-class="el--tooltip-error actions-message__input--tooltip"
          >
            <textarea
              ref="textarea"
              v-model="text"
              name="message"
              cols="30"
              rows="3"
              autofocus
              data-cy="form-message"
              :maxlength="isSms ? 155 : null"
              @dragover="focusTextarea"
              @input="onSmsInput"
              :placeholder="
                isSms ? $t('sms-campaigns.messages.modal.placeholder') : $t('campaign.messages.placeholder.textarea')
              "
              :disabled="disableTextarea"
              :class="{
                'actions-message__input--error': containsDuplicateMessages || showSpecialCharTooltip,
              }"
            ></textarea>
          </el-tooltip>
          <div v-if="loaderRenderMessage" class="dd__loader">
            <base-loader />
          </div>
          <div class="view-edit">
            <div>
              <span v-if="!viewOtherMessage && !loaderRenderMessage" @click="fetchRenderMessage()">{{
                $t('campaign.messages.preview')
              }}</span>
              <span v-if="viewOtherMessage && !loaderRenderMessage" @click="fetchRenderMessage()">{{
                $t('campaign.messages.view-other-message')
              }}</span>
              <span v-if="disableTextarea" @click="enableTextarea()">{{ $t('edit') }}</span>
            </div>
            <span class="d-block count" v-if="isSms">{{ $tc('sms-campaigns.messages.modal.limit') }}</span>
            <span class="d-block count">{{ $tc('campaign.messages.character-count', count) }}</span>
          </div>
        </div>

        <div class="actions-message__oto-ia" v-if="showMessagesIA">
          <label>
            <el-checkbox v-model="isMessageIA">
              <span
                class="actions-message__oto-ia__phrase"
                v-html="$t('360.campaigns.details.oto-ia', { count: `${numberVariations}` })"
              ></span>
              <img :src="require(`@/assets/img/icons/stars-ia.svg`)" />
              <el-popover
                trigger="hover"
                effect="dark"
                placement="top"
                :width="290"
                popper-class="actions-message__tooltip"
                v-if="isVisible && actionPage"
              >
                <p v-html="$t('360.campaigns.details.tooltip-message', { count: numberVariations })"></p>
                <template #reference>
                  <i class="icon icon-question-12px" />
                </template>
              </el-popover>
            </el-checkbox>
          </label>
        </div>

        <div class="actions-message__success-messages" v-if="showSuccessMessagesIA">
          <img :src="require(`@/assets/img/icons/success-green.svg`)" />
          <p v-html="$t('360.campaigns.details.success-messages')"></p>
        </div>

        <div class="actions-message__sms-text" v-if="isSms">
          <img :src="require(`@/assets/img/icons/info-black.svg`)" />
          <span v-html="$t('sms-campaigns.messages.modal.alert')"></span>
        </div>

        <p class="actions-message__optout" v-if="actionPage" v-html="$t('360.campaigns.details.phrase-optout')"></p>

        <hr class="solid mt-4" />
        <!-- submit -->
        <div class="ac-container--button">
          <button
            :disabled="disabledButton"
            class="btn submit mt-3"
            data-cy="btn-create-message"
            type="submit"
            @click.prevent="submit"
          >
            <span v-if="loading">{{ $tc('_loading-dots', 2) }}</span>
            <span v-else-if="loadingMessages">
              <el-icon class="is-loading">
                <Loading />
              </el-icon>
              {{ $t('_creating-messages') }}</span
            >
            <span v-else>
              {{ $t(isEditMode ? 'campaign.messages.save-message' : 'campaign.messages.add-message') }}
            </span>
          </button>
        </div>
      </div>

      <!-- right side -->
      <div class="ac-variables">
        <p>{{ $t('campaign.messages.drag-the-variables-below-into-the-message-field') }}</p>
        <label>{{ $t('campaign.messages.search-variable') }}</label>
        <div class="form-wrapper">
          <input
            v-model="variable"
            class="input-search"
            :placeholder="$t('campaign.messages.placeholder.search')"
            @input="filterVariable()"
          />
          <i class="icon icon-search"></i>
        </div>
        <div class="actions-message__labels customScrollBar">
          <ul>
            <!-- Think in use filterVariable as computed -->
            <li
              v-for="label in filterVariable()"
              :key="label"
              draggable="true"
              @dragstart="
                evt => {
                  onDrag(evt, label);
                }
              "
            >
              {{ label }}
            </li>
          </ul>
        </div>
      </div>
    </form>
    <base-loader v-if="loadingModal" />
  </el-dialog>
</template>

<script>
// libs
import vSelect from 'vue-select';
import { mapState, mapActions } from 'vuex';
import i18n from '@/i18n';
import moment from 'moment';
// helpers
import bus from '@/helpers/events/bus';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';

// services
import { putTemplate, getTemplateVariables, getMessages, getRenderMessage } from '@/services/actions';
import { getScopeValue } from '@/services/scope';
// components
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner';
import { Loading } from '@element-plus/icons-vue';
import { useMessageVariations } from '@/features/CampaignsManagement/composables/useMessagesVariations';
import { useToast } from 'vue-toastification';

const TOTAL_MESSAGES = 10;
const MAX_MESSAGES_FOR_IA = 9;
const GSM_EXTENDED_CHAR = /[{}[\]\\|]/;

export default {
  name: 'ActionsNewMessageModal',
  components: {
    vSelect,
    BaseLoader,
    Loading,
  },
  setup() {
    const toast = useToast();
    const { generateVariations, loadingMessages } = useMessageVariations();

    return {
      toast,
      generateVariations,
      loadingMessages,
    };
  },
  props: {
    type: {
      type: String,
    },
    page: {
      type: String,
    },
  },
  data() {
    return {
      id: 'actions-new-message-modal',
      templateId: null,
      scope: '',
      scopeValue: '',
      channel: 'whatsapp',
      text: '',
      variable: '',
      textWithVariable: '',
      isMessageIA: true,
      channelTypes: [
        {
          id: 'whatsapp',
          name: i18n.global.t('360.whatsapp'),
        },
        {
          id: 'sms',
          name: i18n.global.t('360.sms'),
        },
      ],
      labels: [],
      scopeValueList: [],
      scopeList: [
        {
          id: 'brand',
          name: i18n.global.tc('_brand', 1),
        },
        {
          id: 'action',
          name: i18n.global.tc('_action', 1),
        },
        {
          id: 'campaign',
          name: i18n.global.tc('_campaign', 1),
        },
        {
          id: 'store',
          name: i18n.global.tc('_store', 1),
        },
      ],
      loadingScope: false,
      dradding: null,
      hasError: false,
      loading: false,
      loadingModal: false,
      disableTextarea: false,
      loaderRenderMessage: false,
      viewOtherMessage: false,
      textWillBeSended: '',
      actionPage: false,
      isEditMode: false,
      isVisible: false,
      editedMessage: {},
      showSpecialCharTooltip: false,
      tooltipMessage: '',
    };
  },
  computed: {
    ...mapState('campaignsManagement', ['actionName', 'actionsMessages']),
    titleMessage() {
      return i18n.global.t(this.isEditMode ? 'campaign.messages.edit.message' : 'campaign.messages.new.message');
    },
    showMessagesIA() {
      return this.actionPage && !this.isEditMode && this.actionsMessages.length < MAX_MESSAGES_FOR_IA;
    },
    numberVariations() {
      return MAX_MESSAGES_FOR_IA - this.actionsMessages.length;
    },

    showSuccessMessagesIA() {
      return this.actionPage && this.actionsMessages.length >= TOTAL_MESSAGES;
    },

    isNotSms() {
      return this.type !== 'sms';
    },

    isSms() {
      return this.type === 'sms';
    },

    isSmsCampaignPage() {
      return this.page === 'sms';
    },

    disabledButton() {
      return (
        this.loading ||
        !this.text ||
        this.containsDuplicateMessages ||
        this.loadingMessages ||
        this.showSpecialCharTooltip
      );
    },
    count() {
      if (!this.isSms) return this.text.length;
      return this.calculateSmsLength(this.text);
    },
    containsDuplicateMessages() {
      return this.actionsMessages.some(message => {
        if (this.isEditMode && message.id === this.editedMessage.id) {
          return false;
        }

        return message.text.toLowerCase().replace(/\s/g, '') === this.text.toLowerCase().replace(/\s/g, '');
      });
    },
  },
  watch: {
    isVisible() {
      if (!this.isVisible) this.resetData();
    },
  },
  mounted() {
    this.fetchTemplates();
    const idCampaign = this.$router.currentRoute.value.query?.id;

    if (idCampaign) {
      this.scope = 'campaign';
      this.changeScope();
      this.openModal();
    }

    bus.$on(`open-${this.id}`, templateId => {
      if (templateId) this.isEditMode = true;
      if (this.isSms) {
        this.channel = 'sms';
      }

      if (this.isSmsCampaignPage) mixpanelSmsCampaign.modalSmsViewed();

      this.fetchEditData(templateId);
      this.viewOtherMessage = false;
      this.disableTextarea = false;
      this.openModal();
    });

    bus.$on(`open-${this.id}-edit-sms`, message => {
      this.channel = 'sms';
      this.isEditMode = true;
      this.text = message;
      this.openModal();
    });

    bus.$on(`open-${this.id}-action`, message => {
      this.actionPage = true;
      this.scope = 'action';
      this.scopeValue = this.actionName;

      this.isMessageIA = this.actionsMessages.length < MAX_MESSAGES_FOR_IA && !message;

      if (message) {
        this.isEditMode = true;
        this.text = message.text;
        this.editedMessage = message;
      }

      this.openModal();
    });

    bus.$on('update-selected-brand', () => this.fetchTemplates());
  },
  beforeUnmount() {
    bus.$off(`open-${this.id}`);
    bus.$off(`open-${this.id}-edit-sms`);
    bus.$off('update-selected-brand');
    bus.$off(`open-${this.id}-action`);
  },
  methods: {
    ...mapActions('campaignsManagement', ['setActionsMessages', 'setEditActionsMessages']),
    ...mapActions('smsCampaigns', ['setMessage']),

    calculateSmsLength(text) {
      if (!text) return 0;

      let length = 0;

      for (const char of text) {
        length += GSM_EXTENDED_CHAR.exec(char) ? 2 : 1;
      }

      return length;
    },

    showMessageError() {
      if (this.isSmsCampaignPage) {
        mixpanelSmsCampaign.invalidCharacters(this.text);
      }
    },

    fetchTemplates() {
      getTemplateVariables().then(response => {
        const data = response?.data;
        if (data && data?.success) this.labels = data?.data;
      });
    },

    fetchScopeValue() {
      this.loadingScope = true;
      getScopeValue({ type: this.scope })
        .then(response => {
          const data = response?.data;
          if (data && data?.success) this.scopeValueList = data?.data;

          const idCampaign = this.$router.currentRoute.value.query?.id;
          if (idCampaign) {
            this.scopeValue = this.scopeValueList.find(item => item.id === idCampaign) || {};
          }
        })
        .finally(() => {
          this.loadingScope = false;
        });
    },

    setDrag(id) {
      this.dradding = id;
    },

    onDrag(evt, variable) {
      evt.dataTransfer.setData('text/plain', variable);
      this.setDrag(variable);
    },

    focusTextarea() {
      this.$refs.textarea.focus();
    },

    changeScope() {
      this.scopeValue = '';
      // if scope is type brand, return
      if (this.checkScopeBrand()) return;

      // fetch scope list
      this.fetchScopeValue();
    },

    /**
     * @description if the scope is type brand, disable the scope input
     */
    checkScopeBrand() {
      return this.scope === 'brand';
    },

    fetchEditData(templateId) {
      if (!templateId) return;

      this.loadingModal = true;

      this.templateId = templateId;

      getMessages({ templateId })
        .then(({ data }) => {
          const { name, scope, url, channel, text } = data?.data[0];

          this.name = name;
          this.scope = scope?.key;
          this.scopeValue = scope?.name;
          this.url = url;
          this.channel = channel;
          this.text = text;
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },

    onSmsInput() {
      if (!this.isSms) return;

      const maxCharacters = 155;
      let currentLength = 0;
      let allowedText = '';

      for (const character of this.text) {
        const isExtendedChar = GSM_EXTENDED_CHAR.exec(character) !== null;
        const characterLength = isExtendedChar ? 2 : 1;

        if (currentLength + characterLength > maxCharacters) {
          break;
        }

        currentLength += characterLength;
        allowedText += character;
      }

      if (allowedText !== this.text) {
        this.text = allowedText;
      }

      this.validateSmsText();
    },

    validateSmsText() {
      if (this.isNotSms) return;

      // Blocks any accented character
      const forbiddenRegex = /[^\x20-\x7E\n]/;

      if (forbiddenRegex.test(this.text)) {
        this.showSpecialCharTooltip = true;
        this.tooltipMessage = i18n.global.t('sms-campaigns.messages.modal.error');
        return;
      }

      this.showSpecialCharTooltip = false;
    },

    submit() {
      if (this.isMessageIA && this.actionPage) {
        return this.generateVariations(this.text, this.numberVariations, this.closeModal, this.createActionMessage);
      }

      if (this.actionPage) {
        return this.handleActionPageSubmit();
      }

      if (this.isSms) {
        this.createSmsMessage();
        return;
      }

      return this.handleTemplateSubmit();
    },

    handleActionPageSubmit() {
      if (this.isEditMode) {
        this.updateActionMessage();
      } else {
        this.createActionMessage(this.text);

        this.toast.success(i18n.global.t('360.campaigns.details.success-message-toast'), {
          timeout: 4000,
        });
      }

      this.closeModal();
    },

    createSmsMessage() {
      const text = this.textWillBeSended ? this.textWillBeSended : this.text;

      if (this.isSmsCampaignPage) mixpanelSmsCampaign.saveMessage(text);

      this.$store.commit('smsCampaigns/SET_HAS_INVALID_FIELDS', { key: 'message', value: false });

      this.setMessage([
        {
          message: text,
          createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
          actions: '',
        },
      ]);

      this.closeModal();
    },

    createActionMessage(text) {
      const size = this.actionsMessages.length;
      const id = Date.now().toString();

      this.setActionsMessages({
        createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        channel: 'whatsapp',
        text,
        count: size + 1,
        id: `msg-${id}-${size + 1}`,
      });
    },

    updateActionMessage() {
      const editedId = this.editedMessage.id;

      const updatedMessages = this.actionsMessages.map(msg => {
        if (msg.id === editedId) {
          return {
            ...msg,
            text: this.text,
          };
        }
        return msg;
      });

      this.setEditActionsMessages(updatedMessages);
    },

    handleTemplateSubmit() {
      this.loading = true;

      const templateId = this.templateId || '';
      const scope = this.scope;
      const scopeValue = this.scopeValue?.id;
      const channel = this.channel;
      const text = this.textWillBeSended ? this.textWillBeSended : this.text;
      const idCampaign = this.$router.currentRoute.value.query?.id;

      putTemplate({ templateId, scope, scopeValue, channel, text })
        .then(data => {
          if (!data.data.success) return bus.$emit('open-actions-dialog-error-modal');

          if (idCampaign) {
            localStorage.setItem('campaign-message-created', idCampaign);
          }

          bus.$emit('actions-messages-refresh-list');

          const toastMsg = this.isEditMode
            ? 'campaign.messages.toast.msg-update'
            : 'campaign.messages.toast.msg-success';

          this.toast.success(i18n.global.t(`${toastMsg}`), {
            timeout: 5000,
          });
        })
        .catch(() => {
          bus.$emit('open-actions-dialog-error-modal');
        })
        .finally(() => {
          this.closeModal();
          this.loading = false;
        });
    },

    resetData() {
      this.templateId = null;
      this.isEditMode = false;

      this.scope = '';
      this.scopeValue = '';
      this.channel = 'whatsapp';
      this.text = '';
    },

    fetchRenderMessage() {
      this.loaderRenderMessage = true;
      if (!this.viewOtherMessage || !this.disableTextarea) {
        this.textWithVariable = this.text;
        this.textWillBeSended = this.textWithVariable;
      } else {
        this.textWillBeSended = this.textWithVariable;
      }
      this.viewOtherMessage = true;
      getRenderMessage(this.textWillBeSended)
        .then(response => {
          const data = response?.data;
          if (!data?.data) return;
          this.text = data?.data?.message;

          if (this.isSmsCampaignPage) mixpanelSmsCampaign.messagePreview(this.text);

          this.disableTextarea = true;
        })
        .finally(() => {
          this.loaderRenderMessage = false;
        });
    },
    filterVariable() {
      const variables = this.labels[this.channel].filter(item => item.includes(this.variable));
      return this.isSmsCampaignPage ? variables.filter(variable => !variable.includes('cashback')) : variables;
    },
    enableTextarea() {
      this.disableTextarea = false;
      this.text = this.textWillBeSended;
      this.textWillBeSended = '';
    },

    /**
     * @description modal events
     */
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;

      const currentQuery = { ...this.$router.currentRoute.value.query };
      if (currentQuery.id) {
        delete currentQuery.id;
        this.$router.replace({ query: currentQuery });
      }
    },
  },
};
</script>

<style lang="scss">
.el-popper.is-dark.actions-message__tooltip {
  background-color: #171717 !important;

  .el-popper__arrow::before {
    background-color: #171717 !important;
  }
}

.modal-sms {
  height: 415px !important;
}

.actions-message {
  height: 100% !important;

  &__sms-text {
    font-size: 12px;

    img {
      margin-right: 4px;
    }
  }

  &__input {
    &--tooltip {
      max-width: 270px !important;
    }

    &--error {
      @include error-inputs;
    }
  }

  &__oto-ia {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: inherit !important;
    }

    .el-checkbox__inner {
      border-color: #b3b3b3 !important;
    }

    &__phrase {
      font-size: 12px;
    }

    p {
      font-weight: 500;
      font-size: 12px;
      color: #535353;
    }

    &__name {
      color: $purple-400;
    }

    img {
      margin-left: 3px;
      margin-right: 5px;
    }
  }
}

#actions-new-message-modal {
  @import '@/assets/scss/vendors/_v-select';

  width: 800px;
  height: 530px;
  padding: 0;

  .el-dialog__header {
    position: absolute;
    z-index: 1;
    right: 0;
  }

  .el-dialog__body {
    padding: 0;
    overflow: hidden;
    height: 100%;
  }

  .customScrollBar {
    &::-webkit-scrollbar-thumb {
      background: $gray-500;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: $gray-500;
    }
    &::-webkit-scrollbar-thumb:active {
      background: $gray-500;
    }
  }

  .actions-message {
    height: 580px;
    display: flex;

    &__success-messages {
      display: flex;
      align-items: flex-start;

      img {
        margin-right: 8px;
      }

      p {
        color: #1ea657;
        font-weight: 500;
        font-size: 12px;
        margin-bottom: 6px;
      }
    }

    &__optout {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: $gray-600;
    }

    .ac-form {
      width: 65%;
      padding: 28px 48px 32px 40px;
    }

    .ac-variables {
      width: 35%;
      padding: 78px 32px 40px 24px;
      background-color: $gray-200;
      border-radius: 0 10px 10px 0;
    }

    .actions-message__labels {
      height: 335px;
      max-width: 232px;
      overflow: auto;
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;

        li {
          margin: 2px;
          border-radius: 5px;
          background-color: $oto-omni;
          color: $color-white;
          font-style: normal;
          font-weight: normal;
          font-size: 11px;
          line-height: 16px;
          padding: 5px;
          cursor: move;
        }
      }
    }
    .drag-drop {
      position: relative;
      margin-top: 20px;

      textarea {
        width: 100%;
        min-height: 126px;
        border: 1px solid $gray-500;
        box-sizing: border-box;
        border-radius: 15px;
        padding: 20px 12px;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
        color: $gray-600;
      }

      textarea:disabled {
        background-color: $gray-200;
      }

      .view-edit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        div {
          span:nth-child(1) {
            margin-right: 15px;
          }
          span {
            font-size: 12px;
            color: $blue-500;
            cursor: pointer;
          }
        }
      }

      .count {
        color: $gray-600;
        cursor: default;
        font-size: 12px;
      }
    }

    .ac-container--button {
      button.submit {
        padding: 0 30px;
        width: 400px;
        margin: 0 auto;
      }

      .is-loading {
        font-size: 18px;
        position: relative;
        top: 4px;
      }
    }

    hr {
      margin-left: -50px;
      width: calc(100% + 100px);
    }
    .form-wrapper {
      position: relative;
      z-index: 1;
      margin-bottom: 18px;

      .input-search {
        width: 100%;
        background-color: transparent;
        height: 36px;
      }
      .icon-search {
        color: $gray-500;
        position: absolute;
        top: 3px;
        right: 8px;
      }
    }
  }
  .dd__loader {
    position: absolute;
    width: 30px;
    right: 189px;
    top: 70px;
    height: 35px;
  }
}
</style>
